// extracted by mini-css-extract-plugin
export var backdropBlur = "_ck-0";
export var contentCard = "_ck-5";
export var frame = "_ck-2";
export var image = "_ck-4";
export var imagePane = "_ck-3";
export var modal = "_ck-1";